import { useState, useEffect } from "react";
import { Routes, Route, Link, useLocation, Navigate } from "react-router-dom";
import { 
  LayoutDashboard, Calendar, Users, Video, MessageSquare, 
  Settings, Menu, X, LogOut, FileText, Globe
} from "lucide-react";
import { Button } from "@/components/ui/button";
import axios from "axios";

// Admin Pages
import AdminAppointments from "./AdminAppointments";
import AdminVideos from "./AdminVideos";
import AdminOverview from "./AdminOverview";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const navItems = [
  { icon: LayoutDashboard, label: "Overview", href: "/admin" },
  { icon: Calendar, label: "Appointments", href: "/admin/appointments" },
  { icon: Video, label: "Videos", href: "/admin/videos" },
];

export default function AdminDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-100" data-testid="admin-dashboard">
      {/* Mobile Header */}
      <div className="lg:hidden bg-slate-900 text-white p-4 flex items-center justify-between">
        <span className="font-bold">Admin Panel</span>
        <button onClick={() => setSidebarOpen(!sidebarOpen)}>
          {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <div className="flex">
        {/* Sidebar */}
        <aside className={`
          fixed lg:static inset-y-0 left-0 z-50 w-64 bg-slate-900 text-white transform transition-transform duration-200
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}>
          <div className="p-6 border-b border-slate-800">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                <span className="text-slate-900 font-bold">SS</span>
              </div>
              <div>
                <div className="font-bold text-sm">Dr. Sachdeva</div>
                <div className="text-xs text-slate-400">Admin Panel</div>
              </div>
            </Link>
          </div>

          <nav className="p-4 space-y-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href || 
                (item.href !== "/admin" && location.pathname.startsWith(item.href));
              return (
                <Link
                  key={item.label}
                  to={item.href}
                  onClick={() => setSidebarOpen(false)}
                  className={`admin-nav-item ${isActive ? 'active' : ''}`}
                  data-testid={`admin-nav-${item.label.toLowerCase()}`}
                >
                  <item.icon className="w-5 h-5" />
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-slate-800">
            <Link to="/">
              <Button variant="ghost" className="w-full justify-start text-slate-400 hover:text-white hover:bg-slate-800">
                <Globe className="w-5 h-5 mr-3" />
                View Website
              </Button>
            </Link>
          </div>
        </aside>

        {/* Main Content */}
        <main className="flex-1 min-h-screen">
          <Routes>
            <Route index element={<AdminOverview />} />
            <Route path="appointments" element={<AdminAppointments />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </main>
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
}
